import { render, staticRenderFns } from "./DiscoverList.vue?vue&type=template&id=1a9d1090&scoped=true&"
import script from "./DiscoverList.vue?vue&type=script&lang=js&"
export * from "./DiscoverList.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverList.vue?vue&type=style&index=0&id=1a9d1090&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9d1090",
  null
  
)

export default component.exports